import React from 'react';
import Container from './container';
import { StaticImage } from 'gatsby-plugin-image';
import Button from '@mui/material/Button';
import getAnonyUserId from '../services/getAnonyUserId';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import useWindowDimensions from '../hooks/useWindowDimensions';
import LogoMobile from '../assets/logo-aprendizap-mob.svg';

import * as styles from './header.module.css';

const Header = () => {
  const screen = useWindowDimensions();
  const isMobile = screen.width < 811;

  const userId = getAnonyUserId();

  const isBrowser = typeof window !== 'undefined';
  const passingSearch = isBrowser
    ? window.location.search.replace('?', '&')
    : '';
  const skipPhone =
    isBrowser && !!localStorage.getItem('phone_number')
      ? '&skipPhone=true'
      : '';

  return (
    <Container as="header">
      <div className={styles.headerContainer}>
        <a
          href={`${process.env.GATSBY_APP_BASE_URL}?utm_origin=SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
        >
          {isMobile ? (
            <img src={LogoMobile} alt="Logo do Aprendizap" />
          ) : (
            <StaticImage
              src="../assets/logoAprendizap.png"
              alt="Logo do Aprendizap"
            />
          )}
        </a>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <a
            className={styles.moreLessonsBtn}
            href={`${process.env.GATSBY_APP_BASE_URL}/recomendadas?utm_origin=SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
          >
            Ver mais aulas
          </a>
          <a
            href={`${process.env.GATSBY_APP_BASE_URL}/login?utm_origin=SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
          >
            <Button variant="contained" className={styles.signUpBtn}>
              <ExitToAppIcon style={{ marginRight: 8 }} /> Entrar
            </Button>
          </a>
        </div>
      </div>
    </Container>
  );
};

export default Header;
